<template>

    <div class="panel-wrapper">

        <!-- HEADER -->
        <div class="header" :style="{ backgroundColor: cssPropColor('$color-primary') }">
            <span class="icon">
                <label @click="closePanel($event)" for="panel-toggle" title="Close"><i class="icon-MBR_close" aria-hidden="true"></i></label>
            </span>
            <span class="label" v-html="title"></span>
        </div>
        <!-- END HEADER -->

        <!-- CONTENT -->
        <div class="panel-content" data-simplebar>

            <!-- BODY -->
            <div class="body">
                <div class="inner" v-html="content"></div>
            </div>
            <!-- END BODY -->

        </div>
        <!-- END CONTENT -->

    </div>

</template>


<script>

    let vm = {};

    export default {

        name: 'panel-content-terms',

        props: ['panel'],

        components: {},

        data() {
            return {
                title: 'Terms and Conditions'
            }
        },

        computed: {

            content() {
                return this.$dataStore.getters.getTermsData;
            }

        },

        created() {
            //console.info('%csidebar-content-privacy::created', 'color:dodgerblue;');
        },

        mounted() {
            //console.info('%csidebar-content-privacy::mounted', 'color:green;');

            vm = this;
        },

        methods: {

            closePanel(evt) {
                vm.$eventBus.$emit('residence:zoomout');
            },

            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            }

        },

        events: {

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .panel-wrapper {
        height: 100%;
        position: relative;
        animation-duration: 0s;
        animation-delay: 0.6s;
    }

    .panel-content {

        & .body {

            & ul {
                padding-left: 18px;
                margin-top: 1rem;
                margin-bottom: 1rem;
            }
        }
    }

</style>

<style lang="scss">

    @import '../assets/styles/helpers/variables';

    .panel-content {

        & .body {

            & ul {
                padding-left: 18px;
                margin-top: 1rem;
                margin-bottom: 1rem;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// PanelContentTerms.vue?0d044d34